import React, { Component } from 'react';
import { Button } from '@massds/mayflower-react';
import {
  ComposableMap, ZoomableGroup, Geographies, Geography
} from 'react-simple-maps';
import { scaleQuantile } from 'd3-scale';
import { schemeRdYlGn } from 'd3-scale-chromatic';
import axios from 'axios';
import csv from 'csvtojson';
import ReactTooltip from 'react-tooltip';
import { quantile, ascending } from 'd3-array';
import LegendQuantile from '../Legend/Quantile';
import { customFormat0 } from '../helper';
import './Map.css';

import masstowns from '../data/masstowns.topo.json';

const colorScaleQuant = scaleQuantile();

class OriginTripsCapMap extends Component {
  constructor() {
    super();
    this.state = {
      allData: [],
      center: [-71.63627925574303, 42.13276308419552],
      zoom: 1,
      disablePan: true,
      colorScale: colorScaleQuant,
      areas: [
        {
          name: 'Greater Boston', coordinates: [-71.036279, 42.332763], zoom: 5, radius: 5, colorScale: colorScaleQuant, annotation: ['', 0, '', 0]
        },
        {
          name: 'Cape Cod', coordinates: [-70.188761, 41.681497], zoom: 2, colorScale: colorScaleQuant, annotation: ['', 0, '', 0]
        },
        {
          name: 'North Shore', coordinates: [-70.982613, 42.655939], zoom: 4, colorScale: colorScaleQuant, annotation: ['', 0, '', 0]
        },
        {
          name: 'Central Mass', coordinates: [-72.217152, 42.419665], zoom: 3, colorScale: colorScaleQuant, annotation: ['', 0, '', 0]
        },
        {
          name: 'Western Mass', coordinates: [-73.014503, 42.399396], zoom: 3, colorScale: colorScaleQuant, annotation: ['', 0, '', 0]
        }
      ]
    };
    this.handleAreaSelection = this.handleAreaSelection.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  parseData = (data) => {
    const allData = [];
    csv({
      noheader: false
    }).fromString(data)
      .subscribe((json) => {
        allData.push(json);
      })
      .on('done', () => {
        this.setState({ allData });
      })
      .on('error', (err) => {
        console.log(err);
      });
  }

  fetchData = () => {
    const _this = this;
    axios.all([axios.get('../data/town_summary.csv')])
      .then(axios.spread((result) => {
        const { data } = result;
        _this.parseData(data);
      }))
      .catch((error) => { console.log(error); });
  };

  handleAreaSelection(e, i) {
    const { areas } = this.state;
    const area = areas[i];
    this.setState({
      center: area.coordinates,
      zoom: area.zoom,
      colorScale: area.colorScale,
      disablePan: false
    });
  }

  handleReset() {
    this.setState({
      center: [-71.63627925574303, 42.13276308419552],
      zoom: 1,
      disablePan: true
    });
  }

  render() {
    const {
      allData, colorScale, areas, center, zoom, disablePan
    } = this.state;
    if (allData.length === 0) {
      return<div className="container">Loading...</div>;
    }
    const speedArray = allData.map((item) => {
      if (Number(item.AVG_ORIGIN_SPEED) > 0) {
        return Number(item.AVG_ORIGIN_SPEED);
      } return null;
    });
    speedArray.sort(ascending);
    const breaks = [14, quantile(speedArray, 0.125), quantile(speedArray, 0.25), quantile(speedArray, 0.375), quantile(speedArray, 0.5), quantile(speedArray, 0.625), quantile(speedArray, 0.75), quantile(speedArray, 0.875), quantile(speedArray, 1.00)];
    colorScale.domain(breaks).range(schemeRdYlGn[9]);

    return(
      <div>
        <div className="wrapperButtonStyles">
          {
            areas.map((area, i) => (
              <Button
                size="small"
                info="Zoom to area on map."
                text={area.name}
                onClick={(e) => this.handleAreaSelection(e, i)}
                usage="secondary"
                // eslint-disable-next-line react/no-array-index-key
                key={`speedmap_button_${area.name}`}
              />
            ))
          }
          <Button
            size="small"
            info="Zoom out to full state."
            text="Reset"
            onClick={this.handleReset}
            usage="secondary"
            // eslint-disable-next-line react/no-array-index-key
            key="speedmap_button_reset"
            theme="c-primary-alt"
          />
        </div>
        <div className="wrapperStyles">
          <div className="wrapperMapStyles">
            <ComposableMap
              projection="mercator"
              projectionConfig={{
                scale: 12000
              }}
              width={980}
              height={530}
              style={{
                width: '100%',
                height: 'auto'
              }}
            >
              <ZoomableGroup center={center} zoom={zoom} disablePanning={disablePan}>
                <Geographies geography={masstowns} disableOptimization>
                  {(geographies, projection) => geographies.map((geography, i) => {
                    const townData = allData.find((s) => s.FIPS_CODE === geography.id) || {};
                    const town = townData.TOWN;
                    const metric = townData.AVG_ORIGIN_SPEED;
                    const fill = colorScale(metric);
                    const tooltipVal = metric && metric > 0 ? (`${customFormat0(metric)} miles per hour`) : 'No Data';
                    return(
                      <Geography
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${i}two`}
                        cacheId={`${i}two`}
                        round
                        geography={geography}
                        projection={projection}
                        data-html
                        data-tip={`<strong>${town}</strong><br><strong>Average Speed</strong>: ${tooltipVal}`}
                        style={{
                          default: {
                            fill: metric < 1 ? '#dcdcdc' : fill,
                            stroke: '#dcdcdc',
                            strokeWidth: 0.5,
                            outline: 'none'
                          },
                          hover: {
                            fill: metric < 1 ? '#dcdcdc' : fill,
                            stroke: 'rgba(255,255,255,1.0)',
                            fillOpacity: '0.7',
                            strokeWidth: 2.00,
                            outline: 'true'
                          },
                          pressed: {
                            fill: metric < 1 ? '#dcdcdc' : fill,
                            stroke: 'rgba(255,255,255,1.0)',
                            fillOpacity: '0.3',
                            strokeWidth: 2.00,
                            outline: 'true'
                          }
                        }}
                      />
                    );
                  })}
                </Geographies>
              </ZoomableGroup>
            </ComposableMap>
            <ReactTooltip type="light" />
          </div>
          <div className="wrapperLegendStyles">
            <p className="legendTitle">
              Average Speed
              <br />
              (miles per hour)
            </p>
            <LegendQuantile
              scale={colorScale}
              direction="column"
              labelMargin="0 0 0 0"
              shape="rect"
              labelFormat={customFormat0}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default OriginTripsCapMap;
